import { PlannerRoutes, AccountRoutes, AuthRoutes } from "./routes";
import { Navigate } from "react-router-dom";

import { LoadingScreen } from "../ui/components/LoadingScreen";
import { useCheckRole } from "../hooks";

import Cookies from "js-cookie";


export const PrivatePlannerRoutes: React.FC = () => {
  const { hasRole, isCheckingRole } = useCheckRole("PLANNER_ROLE");

  if (isCheckingRole) {
    return <LoadingScreen />;
  }

  if (!hasRole) {
    return <Navigate to="/auth/" />;
  }

  return <PlannerRoutes />;
};

export const PrivateUserRoutes: React.FC = () => {
  const { hasRole, isCheckingRole } = useCheckRole("USER_ROLE");

  if (isCheckingRole) {
    return <LoadingScreen />;
  }

  if (!hasRole) {
    return <Navigate to="/auth/" />;
  }

  return <AccountRoutes />;
};


export const AuthRoutesValidator: React.FC = () => {

  const token = Cookies.get("token");

  if (token) {
    return <Navigate to="/account" />;
  }


  return <AuthRoutes />;
};

